import purify from 'dompurify';
import { datadogPhiMaskProps } from 'toolkit/environment/environment/userMonitoring.util';

// Use this component whenever you want to render pure html
// It will sanitize the html before rendering to prevent XSS attacks
const HtmlDisplayer = (props: { innerHtml: string; className?: string }) => {
  const sanitizedHtml = purify.sanitize(props.innerHtml);
  return (
    <div
      {...datadogPhiMaskProps}
      className={props.className}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    ></div>
  );
};

export default HtmlDisplayer;
